import request from "@/utils/request";

// 政策资讯列表
export function getPolicyList(params) {
  return request({
    url: "/wechat/service/provider/getPolicySouthEastList",
    method: "get",
    params
  });
}
// 政策资讯详情
export function getPolicyDetail(params) {
  return request({
    url: `/wechat/service/provider/policy/${params}`,
    method: "get"
  });
}
// 智能养老顾问列表
export function getSmartCareList(params) {
  return request({
    url: `/wechat/intelligent/pension/adviser`,
    method: "get",
    params
  });
}
// 模糊查询智能养老顾问列表
export function getFuzzyCareList(data) {
  return request({
    url: `/wechat/intelligent/peopleslivelihood/pension/adviser/nandong`,
    method: "POST",
    data
  });
}
